var map = {
	"./ca-AD.json": 1464,
	"./ca-ES.json": 1465,
	"./en-US.json": 1466,
	"./es-AR.json": 1467,
	"./es-CL.json": 1468,
	"./es-CO.json": 1469,
	"./es-ES.json": 1470,
	"./es-MX.json": 1471,
	"./eu-ES.json": 1472,
	"./fr-FR.json": 1473,
	"./it-IT.json": 1474
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1463;


//////////////////
// WEBPACK FOOTER
// ./src/locales ^\.\/.*\.json$
// module id = 1463
// module chunks = 22